import { PriceImpact } from 'types/Price';
import { OptionStatus } from 'types/ProductOptionGroup';
import { useFormatAmount } from 'utils/formatAmount';
import { FormattedMessage, MessageDescriptor } from 'utils/intl';

import messages from './optionInfo.messages';

const statusMessagesMap: Partial<{ [key in OptionStatus]: MessageDescriptor }> = {
  soon: messages.soon,
  inactive: messages.inactive,
};

const useOptionInfo = (): ((status?: OptionStatus, priceImpact?: PriceImpact) => JSX.Element | string | null) => {
  const formatAmount = useFormatAmount();

  return (
    status: OptionStatus = 'inactive',
    priceImpact: PriceImpact | undefined = undefined
  ): JSX.Element | string | null => {
    if (statusMessagesMap[status]) {
      return <FormattedMessage {...statusMessagesMap[status]} />;
    }

    if (priceImpact?.amount) {
      const { amount, currency, hasImpact } = priceImpact;
      return formatAmount({ amount, currency }, hasImpact ? { signDisplay: 'exceptZero' } : undefined);
    }

    return null;
  };
};

export { useOptionInfo };
